import {useRef, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {ToastService} from '../../AppToast';
import {localized, useTranslation} from '../language';

interface ImExExcelProps {
  exportTemplate(): Promise<any>;
  exportExcel(params: any): Promise<any>;

  exportExcelFileName?: string;

  importExcel(data: any): Promise<any>;

  reloadLazyData(result?: any): void;
}

export const useImExExcel = (props: ImExExcelProps) => {
  const {t} = useTranslation();

  const {exportTemplate, exportExcel, exportExcelFileName, importExcel, reloadLazyData} = props;

  const input = useRef(null);

  const [display, setDisplay] = useState(false);
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const download = (params) => {
    if (!submitting) {
      setSubmitting(true);

      exportExcel(params).then((data) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([data]));
        link.download = `${exportExcelFileName}.xlsx`;
        link.click();

        setSubmitting(false);
      });
    }
  }

  const showImportDialog = () => {
    setFile(null);
    setDisplay(true);
  }

  const downloadTemplate = () => {
    if (!submitting) {
      setSubmitting(true);

      exportTemplate().then((data) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([data]));
        link.download = `file-mau-${exportExcelFileName}.xlsx`;
        link.click();

        setSubmitting(false);
      });
    }
  }

  const onUploadExcelFile = (event) => {
    if (event && event.target && event.target.files && event.target.files.length) {
      setFile(event.target.files[0]);
    }
  }

  const handleSubmit = () => {
    if (file) {
      if (!submitting) {
        setSubmitting(true);

        const formData = new FormData();
        formData.append('files', file);
        importExcel(formData).then(result => {
          setDisplay(false);
          ToastService.success();
          reloadLazyData(result);
        }).finally(() => {
          setSubmitting(false);
          input.current.value = '';
        });
      }
    } else {
      ToastService.error(localized('common.fileRequired'));
    }
  }

  const renderImExExcel = () => {
    return (
      <Dialog header={t('common.importExcel')} visible={display} style={{width: '40rem'}} position="top" onHide={() => setDisplay(false)}>
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-12">
            <label htmlFor="file">{t('common.chooseFile')}</label>
            <input ref={input} id="file" type="file" accept=".xlsx, .xls" onChange={onUploadExcelFile}/>
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label={t('common.downloadTemplate')} icon="pi pi-file-excel" onClick={downloadTemplate} loading={submitting} className="p-button-sm p-button-help mr-2"/>
          <Button label={t('common.receiveFile')} icon="pi pi-upload" onClick={handleSubmit} loading={submitting} className="p-button-sm mr-2"/>
          <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    );
  }
  return {renderImExExcel, download, showImportDialog};
}
